import styled from '@emotion/styled';

export const StyledHeading = styled('h1')`
  font-size: 30px;
  line-height: 1.5;
  font-weight: 500;
  //border-left: 2px solid #682BD3;
  padding: 0 0px;
  flex: 1;
  margin-top: 0;
  color: ${props => props.theme.colors.heading};
`;

export const Edit = styled('div')`
  padding: 1rem 1.5rem;
  text-align: right;

  a {
    font-size: 16px;
    font-weight: 500;
    line-height: 1em;
    border: 1px solid rgb(211, 220, 228);
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s ease-out 0s;
    text-decoration: none;
    color: #36313B;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;
    height: 30px;
    padding: 5px 16px;
    line-height 27.76px

    &:hover {
      background-color: rgb(245, 247, 249);
    }
  }
`;

export const StyledMainWrapper = styled.div`
  max-width: 750px;
  color: ${props => props.theme.colors.text};

  ul,
  ol {
    -webkit-padding-start: 40px;
    -moz-padding-start: 40px;
    -o-padding-start: 40px;
    margin: 24px 0px;
    padding: 0 0 0 2em;

    li {
      font-weight: 400;
      font-family: Open Sans,system-ui,BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
      line-height: 28px;
      font-size: 16px;
      color: rgba(35,38,59,1);
    }
  }

  a {
    color: ${props => props.theme.colors.link};
    text-decoration: none;
    transition: all 100ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
    border-bottom: 1px solid #cbb5e2;

    &:hover {
      border-bottom-color: #7048a7;
    }
  }

  code {
    border: 1px solid #ede7f3;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 0.9375em;

    background: ${props => props.theme.colors.background};
  }

  @media (max-width: 767px) {
    padding: 0 15px;
  }
`;
